module.exports = __webpack_public_path__ + "Poppins-Regular.731a28a413d642522667.ttf";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/fonts/poppins/Poppins-Regular.ttf
// module id = ../../../../../src/assets/fonts/poppins/Poppins-Regular.ttf
// module chunks = main